import { useMemo } from 'react';
import { ConsentInput, ConsentKey, CookieNoticeConsentData, UiPermission } from '../types';
export function useConsentData(c: CookieNoticeConsentData[]) {
  const data = useMemo(() => c.filter(d => !d.required), [c]);
  function getConsentFromPermission(permission: CookieNoticeConsentData['id']) {
    return data.find(d => d.id === permission)?.consent_properties;
  }
  function getAcceptedConsent() {
    return data.reduce<ConsentInput>((acc, consent) => {
      if (!consent) return acc;
      const consentProperties = consent.consent_properties || [];
      return {
        ...acc,
        ...Object.fromEntries(consentProperties.map(prop => [prop, 'granted']))
      };
    }, {} as ConsentInput);
  }
  function getDeclinedConsent() {
    return data.reduce<ConsentInput>((acc, consent) => {
      if (!consent) return acc;
      const consentProperties = consent.consent_properties || [];
      return {
        ...acc,
        ...Object.fromEntries(consentProperties.map(prop => [prop, 'denied']))
      };
    }, {} as ConsentInput);
  }
  function getPermissionFromConsent(consent: ConsentInput) {
    const result = Object.entries(consent).reduce((acc, [key, value]) => {
      const permission = data.find(d => d.consent_properties.includes(key as ConsentKey));
      if (permission) {
        acc[permission.id] = value === 'granted';
      }
      return acc;
    }, {} as UiPermission);
    return result;
  }
  return {
    getConsentFromPermission,
    getPermissionFromConsent,
    getAcceptedConsent,
    getDeclinedConsent
  };
}